import orderList from "@/views/FAMILY OF CONSUMER COMPANIES";
import imports from "@/views/imports";
import search from "@/views/search";
import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/search",
      name: "search",
      component: search
    },
    {
      path: "/order",
      name: "orderList",
      component: orderList
    },
    {
      path: "/imports",
      name: "imports",
      component: imports
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js